import { getChainById, renderToPlainText, ROUND_PAYOUT_DIRECT, truncateDescription } from "common";
import { getDaysLeft, getRoundStates } from "../api/utils";
import { BasicCard, CardContent, CardDescription, CardHeader, CardTitle } from "../common/styles";
import RoundBanner from "./CardBanner";
import { RoundDaysDetails } from "./RoundDaysDetails";
import { RoundMatchAmountBadge } from "./RoundMatchAmountBadge";
import { RoundStrategyBadge } from "./RoundStrategyBadge";
import { RoundTimeBadge } from "./RoundTimeBadge";
import { RoundProjects } from "./RoundProjects";
import { parseChainIdIntoResult, stringToBlobUrl } from "common/dist/chains";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const RoundCard = _ref => {
  var _applications$length, _applications$filter$, _roundMetadata$eligib, _roundMetadata$eligib2, _getChainById;
  let {
    round,
    index,
    roundType
  } = _ref;
  const {
    id,
    chainId,
    matchAmount,
    applications,
    strategyName,
    donationsStartTime,
    donationsEndTime,
    roundMetadata,
    applicationsStartTime,
    applicationsEndTime,
    matchTokenAddress
  } = round !== null && round !== void 0 ? round : {};
  const parsedChainId = parseChainIdIntoResult(chainId);
  if (parsedChainId.type === "error") {
    return null;
  }
  const donationsStartTimeTimestampSec = donationsStartTime !== null ? Math.round(new Date(donationsStartTime).getTime() / 1000).toString() : Number.MAX_SAFE_INTEGER;
  const donationsEndTimeTimestampSec = donationsEndTime !== null ? Math.round(new Date(donationsEndTime).getTime() / 1000).toString() : Number.MAX_SAFE_INTEGER;
  const applicationsEndTimeTimestampSec = applicationsEndTime !== null ? Math.round(new Date(applicationsEndTime).getTime() / 1000).toString() : Number.MAX_SAFE_INTEGER;
  const roundEndsIn = donationsEndTime === null ? undefined : getDaysLeft(Math.round(new Date(donationsEndTime).getTime() / 1000).toString());
  const roundStartsIn = donationsStartTime === null ? undefined : getDaysLeft(Math.round(new Date(donationsStartTime).getTime() / 1000).toString());
  const applicationsStartsIn = applicationsStartTime === null ? undefined : getDaysLeft(Math.round(new Date(applicationsStartTime).getTime() / 1000).toString());
  const applicationsEndsIn = applicationsEndTime === null ? undefined : getDaysLeft(Math.round(new Date(applicationsEndTime).getTime() / 1000).toString());
  const roundStates = getRoundStates({
    roundStartTimeInSecsStr: donationsStartTimeTimestampSec === null || donationsStartTimeTimestampSec === void 0 ? void 0 : donationsStartTimeTimestampSec.toString(),
    roundEndTimeInSecsStr: donationsEndTimeTimestampSec === null || donationsEndTimeTimestampSec === void 0 ? void 0 : donationsEndTimeTimestampSec.toString(),
    applicationsEndTimeInSecsStr: applicationsEndTimeTimestampSec === null || applicationsEndTimeTimestampSec === void 0 ? void 0 : applicationsEndTimeTimestampSec.toString(),
    atTimeMs: Date.now()
  });
  const totalApplicationCount = (_applications$length = applications === null || applications === void 0 ? void 0 : applications.length) !== null && _applications$length !== void 0 ? _applications$length : 0;
  const approvedApplicationCount = (_applications$filter$ = applications === null || applications === void 0 ? void 0 : applications.filter(application => (application === null || application === void 0 ? void 0 : application.status) === "APPROVED").length) !== null && _applications$filter$ !== void 0 ? _applications$filter$ : 0;
  const getTrackEventValue = (roundType, index) => {
    if (roundType === "all") return "round-card";
    if (roundType === "endingSoon") return "home-rounds-ending-card";
    if (roundType === "active") {
      const isDivisibleBy3 = index % 3 === 0;
      const isDivisibleBy4 = index % 4 === 0;
      return isDivisibleBy3 && isDivisibleBy4 ? "home-donate-now-card-big" : "home-donate-now-card-small";
    }
    return "round-card";
  };
  const trackEventValue = getTrackEventValue(roundType, index);
  return /*#__PURE__*/_jsx(BasicCard, {
    className: "w-full",
    children: /*#__PURE__*/_jsxs("a", {
      href: `/#/round/${chainId}/${id}`,
      "data-testid": "round-card",
      "data-track-event": trackEventValue,
      rel: "noreferrer",
      children: [/*#__PURE__*/_jsxs(CardHeader, {
        className: "relative",
        children: [/*#__PURE__*/_jsx(RoundBanner, {
          roundId: id
        }), /*#__PURE__*/_jsx(RoundTimeBadge, {
          roundStates: roundStates
        }), /*#__PURE__*/_jsx(CardTitle, {
          "data-testid": "round-name",
          className: "absolute bottom-1 px-2 text-white",
          children: roundMetadata.name
        })]
      }), /*#__PURE__*/_jsxs(CardContent, {
        children: [/*#__PURE__*/_jsx(CardDescription, {
          "data-testid": "round-description",
          className: "min-h-[96px]",
          children: truncateDescription(renderToPlainText((_roundMetadata$eligib = (_roundMetadata$eligib2 = roundMetadata.eligibility) === null || _roundMetadata$eligib2 === void 0 ? void 0 : _roundMetadata$eligib2.description) !== null && _roundMetadata$eligib !== void 0 ? _roundMetadata$eligib : ""), 240)
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex gap-2 justfy-between items-center",
          children: [/*#__PURE__*/_jsx(RoundDaysDetails, {
            roundStartsIn: roundStartsIn,
            roundEndsIn: roundEndsIn,
            applicationsStartsIn: applicationsStartsIn,
            applicationsEndsIn: applicationsEndsIn
          }), /*#__PURE__*/_jsx(RoundStrategyBadge, {
            strategyName: strategyName
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "border-t"
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex justify-between",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex gap-2",
            children: [/*#__PURE__*/_jsx(RoundProjects, {
              roundStates: roundStates,
              totalApplicationCount: totalApplicationCount,
              approvedApplications: approvedApplicationCount
            }), strategyName !== ROUND_PAYOUT_DIRECT && /*#__PURE__*/_jsx(RoundMatchAmountBadge, {
              chainId: chainId,
              tokenAddress: matchTokenAddress,
              matchAmount: matchAmount
            })]
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx("img", {
              className: "w-8",
              src: stringToBlobUrl((_getChainById = getChainById(chainId)) === null || _getChainById === void 0 ? void 0 : _getChainById.icon),
              alt: ""
            })
          })]
        })]
      })]
    })
  });
};
export const RoundCardLoading = () => /*#__PURE__*/_jsx(BasicCard, {
  className: "w-full h-[378px] animate-pulse"
});
export default function Round(props) {
  return props.isLoading ? /*#__PURE__*/_jsx(RoundCardLoading, {}) : /*#__PURE__*/_jsx(RoundCard, {
    ...props
  });
}